/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropCampaignWindowBody } from './DropCampaignWindowBody';
import {
    DropCampaignWindowBodyFromJSON,
    DropCampaignWindowBodyFromJSONTyped,
    DropCampaignWindowBodyToJSON,
    DropCampaignWindowBodyToJSONTyped,
} from './DropCampaignWindowBody';
import type { DropStorefrontInput } from './DropStorefrontInput';
import {
    DropStorefrontInputFromJSON,
    DropStorefrontInputFromJSONTyped,
    DropStorefrontInputToJSON,
    DropStorefrontInputToJSONTyped,
} from './DropStorefrontInput';
import type { SurfaceSocialConnection } from './SurfaceSocialConnection';
import {
    SurfaceSocialConnectionFromJSON,
    SurfaceSocialConnectionFromJSONTyped,
    SurfaceSocialConnectionToJSON,
    SurfaceSocialConnectionToJSONTyped,
} from './SurfaceSocialConnection';
import type { PageHeroSection } from './PageHeroSection';
import {
    PageHeroSectionFromJSON,
    PageHeroSectionFromJSONTyped,
    PageHeroSectionToJSON,
    PageHeroSectionToJSONTyped,
} from './PageHeroSection';
import type { DropModeBody } from './DropModeBody';
import {
    DropModeBodyFromJSON,
    DropModeBodyFromJSONTyped,
    DropModeBodyToJSON,
    DropModeBodyToJSONTyped,
} from './DropModeBody';
import type { ChallengeTypography } from './ChallengeTypography';
import {
    ChallengeTypographyFromJSON,
    ChallengeTypographyFromJSONTyped,
    ChallengeTypographyToJSON,
    ChallengeTypographyToJSONTyped,
} from './ChallengeTypography';
import type { SurfaceAllowedGame } from './SurfaceAllowedGame';
import {
    SurfaceAllowedGameFromJSON,
    SurfaceAllowedGameFromJSONTyped,
    SurfaceAllowedGameToJSON,
    SurfaceAllowedGameToJSONTyped,
} from './SurfaceAllowedGame';
import type { ChallengeThemeColors } from './ChallengeThemeColors';
import {
    ChallengeThemeColorsFromJSON,
    ChallengeThemeColorsFromJSONTyped,
    ChallengeThemeColorsToJSON,
    ChallengeThemeColorsToJSONTyped,
} from './ChallengeThemeColors';
import type { SurfaceContentBlock } from './SurfaceContentBlock';
import {
    SurfaceContentBlockFromJSON,
    SurfaceContentBlockFromJSONTyped,
    SurfaceContentBlockToJSON,
    SurfaceContentBlockToJSONTyped,
} from './SurfaceContentBlock';
import type { SurfaceThemeConfig } from './SurfaceThemeConfig';
import {
    SurfaceThemeConfigFromJSON,
    SurfaceThemeConfigFromJSONTyped,
    SurfaceThemeConfigToJSON,
    SurfaceThemeConfigToJSONTyped,
} from './SurfaceThemeConfig';
import type { SurfaceStatus } from './SurfaceStatus';
import {
    SurfaceStatusFromJSON,
    SurfaceStatusFromJSONTyped,
    SurfaceStatusToJSON,
    SurfaceStatusToJSONTyped,
} from './SurfaceStatus';
import type { UpdateDropStreamingSettings } from './UpdateDropStreamingSettings';
import {
    UpdateDropStreamingSettingsFromJSON,
    UpdateDropStreamingSettingsFromJSONTyped,
    UpdateDropStreamingSettingsToJSON,
    UpdateDropStreamingSettingsToJSONTyped,
} from './UpdateDropStreamingSettings';
import type { SurfaceVisibility } from './SurfaceVisibility';
import {
    SurfaceVisibilityFromJSON,
    SurfaceVisibilityFromJSONTyped,
    SurfaceVisibilityToJSON,
    SurfaceVisibilityToJSONTyped,
} from './SurfaceVisibility';
import type { PageNavbarConfig } from './PageNavbarConfig';
import {
    PageNavbarConfigFromJSON,
    PageNavbarConfigFromJSONTyped,
    PageNavbarConfigToJSON,
    PageNavbarConfigToJSONTyped,
} from './PageNavbarConfig';
import type { Distribution } from './Distribution';
import {
    DistributionFromJSON,
    DistributionFromJSONTyped,
    DistributionToJSON,
    DistributionToJSONTyped,
} from './Distribution';
import type { DropReleaseBody } from './DropReleaseBody';
import {
    DropReleaseBodyFromJSON,
    DropReleaseBodyFromJSONTyped,
    DropReleaseBodyToJSON,
    DropReleaseBodyToJSONTyped,
} from './DropReleaseBody';
import type { DropType } from './DropType';
import {
    DropTypeFromJSON,
    DropTypeFromJSONTyped,
    DropTypeToJSON,
    DropTypeToJSONTyped,
} from './DropType';
import type { SurfacePointSystemConfigInput } from './SurfacePointSystemConfigInput';
import {
    SurfacePointSystemConfigInputFromJSON,
    SurfacePointSystemConfigInputFromJSONTyped,
    SurfacePointSystemConfigInputToJSON,
    SurfacePointSystemConfigInputToJSONTyped,
} from './SurfacePointSystemConfigInput';
import type { DropSection } from './DropSection';
import {
    DropSectionFromJSON,
    DropSectionFromJSONTyped,
    DropSectionToJSON,
    DropSectionToJSONTyped,
} from './DropSection';
import type { PageSeo } from './PageSeo';
import {
    PageSeoFromJSON,
    PageSeoFromJSONTyped,
    PageSeoToJSON,
    PageSeoToJSONTyped,
} from './PageSeo';
import type { RosterFieldSpec } from './RosterFieldSpec';
import {
    RosterFieldSpecFromJSON,
    RosterFieldSpecFromJSONTyped,
    RosterFieldSpecToJSON,
    RosterFieldSpecToJSONTyped,
} from './RosterFieldSpec';
import type { DropVideoBody } from './DropVideoBody';
import {
    DropVideoBodyFromJSON,
    DropVideoBodyFromJSONTyped,
    DropVideoBodyToJSON,
    DropVideoBodyToJSONTyped,
} from './DropVideoBody';
import type { Prerequisite } from './Prerequisite';
import {
    PrerequisiteFromJSON,
    PrerequisiteFromJSONTyped,
    PrerequisiteToJSON,
    PrerequisiteToJSONTyped,
} from './Prerequisite';

/**
 * Sparse update body — only fields present are written.
 * @export
 * @interface UpdateDropsIdBody
 */
export interface UpdateDropsIdBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    description?: string;
    /**
     * 
     * @type {DropType}
     * @memberof UpdateDropsIdBody
     */
    dropType?: DropType;
    /**
     * 
     * @type {SurfaceStatus}
     * @memberof UpdateDropsIdBody
     */
    status?: SurfaceStatus;
    /**
     * 
     * @type {SurfaceVisibility}
     * @memberof UpdateDropsIdBody
     */
    visibility?: SurfaceVisibility;
    /**
     * How this Drop is served, and in what style, per channel. Replaces the whole list when present; omit the key to leave it untouched.
     * @type {Array<Distribution>}
     * @memberof UpdateDropsIdBody
     */
    distributions?: Array<Distribution>;
    /**
     * 
     * @type {SurfacePointSystemConfigInput}
     * @memberof UpdateDropsIdBody
     */
    pointSystemConfig?: SurfacePointSystemConfigInput;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropsIdBody
     */
    verified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    ownerType?: UpdateDropsIdBodyOwnerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    games?: Array<string>;
    /**
     * 
     * @type {ChallengeThemeColors}
     * @memberof UpdateDropsIdBody
     */
    themeColors?: ChallengeThemeColors;
    /**
     * 
     * @type {ChallengeTypography}
     * @memberof UpdateDropsIdBody
     */
    typography?: ChallengeTypography;
    /**
     * 
     * @type {SurfaceThemeConfig}
     * @memberof UpdateDropsIdBody
     */
    themeConfig?: SurfaceThemeConfig;
    /**
     * 
     * @type {PageHeroSection}
     * @memberof UpdateDropsIdBody
     */
    heroSection?: PageHeroSection;
    /**
     * 
     * @type {PageNavbarConfig}
     * @memberof UpdateDropsIdBody
     */
    navbarConfig?: PageNavbarConfig;
    /**
     * 
     * @type {PageSeo}
     * @memberof UpdateDropsIdBody
     */
    seo?: PageSeo;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    competitionId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    questConfigs?: Array<string>;
    /**
     * 
     * @type {Array<SurfaceAllowedGame>}
     * @memberof UpdateDropsIdBody
     */
    allowedGames?: Array<SurfaceAllowedGame>;
    /**
     * 
     * @type {Array<DropSection>}
     * @memberof UpdateDropsIdBody
     */
    sections?: Array<DropSection>;
    /**
     * 
     * @type {UpdateDropStreamingSettings}
     * @memberof UpdateDropsIdBody
     */
    streamingSettings?: UpdateDropStreamingSettings;
    /**
     * 
     * @type {DropReleaseBody}
     * @memberof UpdateDropsIdBody
     */
    release?: DropReleaseBody;
    /**
     * 
     * @type {Array<DropCampaignWindowBody>}
     * @memberof UpdateDropsIdBody
     */
    campaignWindows?: Array<DropCampaignWindowBody>;
    /**
     * POV this Drop was created as (CREATOR, PUBLISHER, FRANCHISE, GAME, BRAND, COMMUNITY, ESPORTS_PROFESSIONAL, ESPORTS_COLLEGIATE, AGENCY).
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    pov?: string;
    /**
     * The Drop this one hangs off. Siblings are every other Drop with the same parent. Empty string clears it.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    parentDropId?: string;
    /**
     * Roster card fields THIS surface adds over its team's schema, merged by key. For a surface that wants a change without altering every other surface the shared team appears on. Empty array clears; omitting leaves alone.
     * @type {Array<RosterFieldSpec>}
     * @memberof UpdateDropsIdBody
     */
    rosterFields?: Array<RosterFieldSpec>;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    streamingTeamId?: string | null;
    /**
     * 
     * @type {Array<SurfaceSocialConnection>}
     * @memberof UpdateDropsIdBody
     */
    socials?: Array<SurfaceSocialConnection>;
    /**
     * 
     * @type {Array<SurfaceContentBlock>}
     * @memberof UpdateDropsIdBody
     */
    contentBlocks?: Array<SurfaceContentBlock>;
    /**
     * Send null to CLEAR the image. An empty string is deliberately NOT a clear — the editor's controlled input submits "" on an untouched save, and treating that as a clear wiped CDN URLs.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    creatorProfileImageUrl?: string | null;
    /**
     * Send null to CLEAR the image. See creatorProfileImageUrl for why an empty string is not a clear.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    creatorHeaderImageUrl?: string | null;
    /**
     * Wide wordmark lockup rendered as the hero logo. Distinct from the square icon in creatorProfileImageUrl.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    logoImageUrl?: string;
    /**
     * Uploaded icon asset id. Resolves ahead of creatorProfileImageUrl on read. Send null to CLEAR, exactly as the image URLs above — without nullable the generated client types this `string | undefined`, and an undefined is dropped by omitBy(isNil), so removing an uploaded image silently did nothing.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    iconImageId?: string | null;
    /**
     * Uploaded wordmark asset id. Resolves ahead of logoImageUrl on read. Send null to CLEAR — see iconImageId.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    logoImageId?: string | null;
    /**
     * One line under the name. True whether or not anything is launching.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    tagline?: string;
    /**
     * What this Drop is about, in its own words.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    synopsis?: string;
    /**
     * Where a visitor buys or plays. The CTA wording changes with release status; this destination does not.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    purchaseUrl?: string;
    /**
     * The feature video.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    trailerUrl?: string;
    /**
     * Assigned hero-strip videos. Empty falls back to the connected YouTube channel.
     * @type {Array<DropVideoBody>}
     * @memberof UpdateDropsIdBody
     */
    videos?: Array<DropVideoBody>;
    /**
     * The slim rail under the hero — modes pre-launch, the season cadence after. True of a franchise with no launch at all.
     * @type {Array<DropModeBody>}
     * @memberof UpdateDropsIdBody
     */
    modes?: Array<DropModeBody>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    platforms?: Array<string>;
    /**
     * OWGame id once the subject exists in the catalogue. Send null to CLEAR the link — see iconImageId for why nullable is required for a clear to survive the client serialiser.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    gameRef?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    twitchGameIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    kickCategoryIds?: Array<string>;
    /**
     * Lowercased title/tag aliases — often the only signal before a category exists.
     * @type {Array<string>}
     * @memberof UpdateDropsIdBody
     */
    streamTitleAliases?: Array<string>;
    /**
     * The subject's own Steam store app. Send null to CLEAR.
     * @type {number}
     * @memberof UpdateDropsIdBody
     */
    steamAppId?: number | null;
    /**
     * The Steam app whose announcements this subject posts to, when that differs from its store app. Falls back to steamAppId. Send null to CLEAR.
     * @type {number}
     * @memberof UpdateDropsIdBody
     */
    steamNewsAppId?: number | null;
    /**
     * Short credits line under the name — "Activision · Infinity Ward". Authored, unlike description.
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    creditLine?: string;
    /**
     * Puck visual builder native JSON (source of truth when useVisualBuilder is true). additionalProperties is an empty schema (not `true`) so the generated client types values as `any` and accepts the primitive values Puck emits at the top level of its data object.
     * @type {{ [key: string]: any; }}
     * @memberof UpdateDropsIdBody
     */
    pageBuilderData?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof UpdateDropsIdBody
     */
    useVisualBuilder?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateDropsIdBody
     */
    phase?: UpdateDropsIdBodyPhaseEnum;
    /**
     * 
     * @type {Array<Prerequisite>}
     * @memberof UpdateDropsIdBody
     */
    prerequisites?: Array<Prerequisite>;
    /**
     * Creator storefront link-outs (Streamlabs Merch, Shopify, Fourthwall, Gumroad, Ko-fi, Spring). Sparse — when present, replaces the current list. USER edits coexist with PARSER-detected entries. Input shape omits `_id` (Mongo assigns) and `detectedFromUrl` (parser-only — preserved server-side from prior parser entries during round-trip).
     * @type {Array<DropStorefrontInput>}
     * @memberof UpdateDropsIdBody
     */
    storefronts?: Array<DropStorefrontInput>;
}


/**
 * @export
 */
export const UpdateDropsIdBodyOwnerTypeEnum = {
    user: 'user',
    organization: 'organization'
} as const;
export type UpdateDropsIdBodyOwnerTypeEnum = typeof UpdateDropsIdBodyOwnerTypeEnum[keyof typeof UpdateDropsIdBodyOwnerTypeEnum];

/**
 * @export
 */
export const UpdateDropsIdBodyPhaseEnum = {
    pre_launch: 'pre_launch',
    live: 'live'
} as const;
export type UpdateDropsIdBodyPhaseEnum = typeof UpdateDropsIdBodyPhaseEnum[keyof typeof UpdateDropsIdBodyPhaseEnum];


/**
 * Check if a given object implements the UpdateDropsIdBody interface.
 */
export function instanceOfUpdateDropsIdBody(value: object): value is UpdateDropsIdBody {
    return true;
}

export function UpdateDropsIdBodyFromJSON(json: any): UpdateDropsIdBody {
    return UpdateDropsIdBodyFromJSONTyped(json, false);
}

export function UpdateDropsIdBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDropsIdBody {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'] == null ? undefined : json['slug'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'dropType': json['dropType'] == null ? undefined : DropTypeFromJSON(json['dropType']),
        'status': json['status'] == null ? undefined : SurfaceStatusFromJSON(json['status']),
        'visibility': json['visibility'] == null ? undefined : SurfaceVisibilityFromJSON(json['visibility']),
        'distributions': json['distributions'] == null ? undefined : ((json['distributions'] as Array<any>).map(DistributionFromJSON)),
        'pointSystemConfig': json['pointSystemConfig'] == null ? undefined : SurfacePointSystemConfigInputFromJSON(json['pointSystemConfig']),
        'verified': json['verified'] == null ? undefined : json['verified'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerType': json['ownerType'] == null ? undefined : json['ownerType'],
        'games': json['games'] == null ? undefined : json['games'],
        'themeColors': json['themeColors'] == null ? undefined : ChallengeThemeColorsFromJSON(json['themeColors']),
        'typography': json['typography'] == null ? undefined : ChallengeTypographyFromJSON(json['typography']),
        'themeConfig': json['themeConfig'] == null ? undefined : SurfaceThemeConfigFromJSON(json['themeConfig']),
        'heroSection': json['heroSection'] == null ? undefined : PageHeroSectionFromJSON(json['heroSection']),
        'navbarConfig': json['navbarConfig'] == null ? undefined : PageNavbarConfigFromJSON(json['navbarConfig']),
        'seo': json['seo'] == null ? undefined : PageSeoFromJSON(json['seo']),
        'competitionId': json['competitionId'] == null ? undefined : json['competitionId'],
        'questConfigs': json['questConfigs'] == null ? undefined : json['questConfigs'],
        'allowedGames': json['allowedGames'] == null ? undefined : ((json['allowedGames'] as Array<any>).map(SurfaceAllowedGameFromJSON)),
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(DropSectionFromJSON)),
        'streamingSettings': json['streamingSettings'] == null ? undefined : UpdateDropStreamingSettingsFromJSON(json['streamingSettings']),
        'release': json['release'] == null ? undefined : DropReleaseBodyFromJSON(json['release']),
        'campaignWindows': json['campaignWindows'] == null ? undefined : ((json['campaignWindows'] as Array<any>).map(DropCampaignWindowBodyFromJSON)),
        'pov': json['pov'] == null ? undefined : json['pov'],
        'parentDropId': json['parentDropId'] == null ? undefined : json['parentDropId'],
        'rosterFields': json['rosterFields'] == null ? undefined : ((json['rosterFields'] as Array<any>).map(RosterFieldSpecFromJSON)),
        'streamingTeamId': json['streamingTeamId'] == null ? undefined : json['streamingTeamId'],
        'socials': json['socials'] == null ? undefined : ((json['socials'] as Array<any>).map(SurfaceSocialConnectionFromJSON)),
        'contentBlocks': json['contentBlocks'] == null ? undefined : ((json['contentBlocks'] as Array<any>).map(SurfaceContentBlockFromJSON)),
        'creatorProfileImageUrl': json['creatorProfileImageUrl'] == null ? undefined : json['creatorProfileImageUrl'],
        'creatorHeaderImageUrl': json['creatorHeaderImageUrl'] == null ? undefined : json['creatorHeaderImageUrl'],
        'logoImageUrl': json['logoImageUrl'] == null ? undefined : json['logoImageUrl'],
        'iconImageId': json['iconImageId'] == null ? undefined : json['iconImageId'],
        'logoImageId': json['logoImageId'] == null ? undefined : json['logoImageId'],
        'tagline': json['tagline'] == null ? undefined : json['tagline'],
        'synopsis': json['synopsis'] == null ? undefined : json['synopsis'],
        'purchaseUrl': json['purchaseUrl'] == null ? undefined : json['purchaseUrl'],
        'trailerUrl': json['trailerUrl'] == null ? undefined : json['trailerUrl'],
        'videos': json['videos'] == null ? undefined : ((json['videos'] as Array<any>).map(DropVideoBodyFromJSON)),
        'modes': json['modes'] == null ? undefined : ((json['modes'] as Array<any>).map(DropModeBodyFromJSON)),
        'platforms': json['platforms'] == null ? undefined : json['platforms'],
        'gameRef': json['gameRef'] == null ? undefined : json['gameRef'],
        'twitchGameIds': json['twitchGameIds'] == null ? undefined : json['twitchGameIds'],
        'kickCategoryIds': json['kickCategoryIds'] == null ? undefined : json['kickCategoryIds'],
        'streamTitleAliases': json['streamTitleAliases'] == null ? undefined : json['streamTitleAliases'],
        'steamAppId': json['steamAppId'] == null ? undefined : json['steamAppId'],
        'steamNewsAppId': json['steamNewsAppId'] == null ? undefined : json['steamNewsAppId'],
        'creditLine': json['creditLine'] == null ? undefined : json['creditLine'],
        'pageBuilderData': json['pageBuilderData'] == null ? undefined : json['pageBuilderData'],
        'useVisualBuilder': json['useVisualBuilder'] == null ? undefined : json['useVisualBuilder'],
        'phase': json['phase'] == null ? undefined : json['phase'],
        'prerequisites': json['prerequisites'] == null ? undefined : ((json['prerequisites'] as Array<any>).map(PrerequisiteFromJSON)),
        'storefronts': json['storefronts'] == null ? undefined : ((json['storefronts'] as Array<any>).map(DropStorefrontInputFromJSON)),
    };
}

export function UpdateDropsIdBodyToJSON(json: any): UpdateDropsIdBody {
    return UpdateDropsIdBodyToJSONTyped(json, false);
}

export function UpdateDropsIdBodyToJSONTyped(value?: UpdateDropsIdBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
        'name': value['name'],
        'description': value['description'],
        'dropType': DropTypeToJSON(value['dropType']),
        'status': SurfaceStatusToJSON(value['status']),
        'visibility': SurfaceVisibilityToJSON(value['visibility']),
        'distributions': value['distributions'] == null ? undefined : ((value['distributions'] as Array<any>).map(DistributionToJSON)),
        'pointSystemConfig': SurfacePointSystemConfigInputToJSON(value['pointSystemConfig']),
        'verified': value['verified'],
        'ownerId': value['ownerId'],
        'ownerType': value['ownerType'],
        'games': value['games'],
        'themeColors': ChallengeThemeColorsToJSON(value['themeColors']),
        'typography': ChallengeTypographyToJSON(value['typography']),
        'themeConfig': SurfaceThemeConfigToJSON(value['themeConfig']),
        'heroSection': PageHeroSectionToJSON(value['heroSection']),
        'navbarConfig': PageNavbarConfigToJSON(value['navbarConfig']),
        'seo': PageSeoToJSON(value['seo']),
        'competitionId': value['competitionId'],
        'questConfigs': value['questConfigs'],
        'allowedGames': value['allowedGames'] == null ? undefined : ((value['allowedGames'] as Array<any>).map(SurfaceAllowedGameToJSON)),
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(DropSectionToJSON)),
        'streamingSettings': UpdateDropStreamingSettingsToJSON(value['streamingSettings']),
        'release': DropReleaseBodyToJSON(value['release']),
        'campaignWindows': value['campaignWindows'] == null ? undefined : ((value['campaignWindows'] as Array<any>).map(DropCampaignWindowBodyToJSON)),
        'pov': value['pov'],
        'parentDropId': value['parentDropId'],
        'rosterFields': value['rosterFields'] == null ? undefined : ((value['rosterFields'] as Array<any>).map(RosterFieldSpecToJSON)),
        'streamingTeamId': value['streamingTeamId'],
        'socials': value['socials'] == null ? undefined : ((value['socials'] as Array<any>).map(SurfaceSocialConnectionToJSON)),
        'contentBlocks': value['contentBlocks'] == null ? undefined : ((value['contentBlocks'] as Array<any>).map(SurfaceContentBlockToJSON)),
        'creatorProfileImageUrl': value['creatorProfileImageUrl'],
        'creatorHeaderImageUrl': value['creatorHeaderImageUrl'],
        'logoImageUrl': value['logoImageUrl'],
        'iconImageId': value['iconImageId'],
        'logoImageId': value['logoImageId'],
        'tagline': value['tagline'],
        'synopsis': value['synopsis'],
        'purchaseUrl': value['purchaseUrl'],
        'trailerUrl': value['trailerUrl'],
        'videos': value['videos'] == null ? undefined : ((value['videos'] as Array<any>).map(DropVideoBodyToJSON)),
        'modes': value['modes'] == null ? undefined : ((value['modes'] as Array<any>).map(DropModeBodyToJSON)),
        'platforms': value['platforms'],
        'gameRef': value['gameRef'],
        'twitchGameIds': value['twitchGameIds'],
        'kickCategoryIds': value['kickCategoryIds'],
        'streamTitleAliases': value['streamTitleAliases'],
        'steamAppId': value['steamAppId'],
        'steamNewsAppId': value['steamNewsAppId'],
        'creditLine': value['creditLine'],
        'pageBuilderData': value['pageBuilderData'],
        'useVisualBuilder': value['useVisualBuilder'],
        'phase': value['phase'],
        'prerequisites': value['prerequisites'] == null ? undefined : ((value['prerequisites'] as Array<any>).map(PrerequisiteToJSON)),
        'storefronts': value['storefronts'] == null ? undefined : ((value['storefronts'] as Array<any>).map(DropStorefrontInputToJSON)),
    };
}

